import React from 'react'
import styled from 'styled-components'
import IntersectionVisible from 'react-intersection-visible'

const Svg = styled.svg`
  &.not-visible {
    display: none;
  }

  &.visible {
    .pen-drawable {
      stroke-dasharray: 1000;
      stroke-dashoffset: 1000;
      animation: dash-inverted 1.1s ease-in forwards;
      animation-delay: 0s;

      &.inverted {
        animation-delay: 0.5s;
        animation: dash-inverted 1s linear forwards;
      }
    }

    @keyframes dash {
      to {
        stroke-dashoffset: 0;
      }
    }

    @keyframes dash-inverted {
      from {
        stroke-dashoffset: -1000;
      }
      to {
        stroke-dashoffset: 0;
      }
    }
  }
`

export default class Icon extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      visible: false,
    }
  }

  render() {
    const { visible } = this.state
    return (
      <IntersectionVisible
        onHide={() => this.setState({ visible: false })}
        onShow={() => this.setState({ visible: true })}
        options={{ rootMargin: '-30px' }}
      >
        <Svg
          className={visible ? 'visible' : 'not-visible'}
          width="255"
          height="168"
          viewBox="0 0 255 168"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <line
            className="pen-drawable inverted"
            x1="-6.55671e-08"
            y1="139.25"
            x2="161"
            y2="139.25"
            stroke="#F9F8F8"
            strokeWidth="1.5"
          />
          <line
            className="pen-drawable inverted"
            x1="63"
            y1="159.25"
            x2="171"
            y2="159.25"
            stroke="#F9F8F8"
            strokeWidth="1.5"
          />
          <line
            className="pen-drawable inverted"
            x1="36"
            y1="119.25"
            x2="171"
            y2="119.25"
            stroke="#F9F8F8"
            strokeWidth="1.5"
          />
          <circle
            className="pen-drawable"
            cx="227"
            cy="140"
            r="27.25"
            stroke="#F3DE8A"
            strokeWidth="1.5"
          />
          <mask id="path-5-inside-1" fill="white">
            <path d="M43.1684 0L38.7146 9.62347C35.9808 9.93024 33.324 10.5628 30.8048 11.5116L22.4493 4.9634L12.9616 11.8567L16.6073 21.8267C14.9264 23.9294 13.5039 26.2607 12.3673 28.7659L1.83855 30.0279L0 41.6361L9.62348 46.0897C9.93026 48.8236 10.5628 51.4803 11.5116 53.9995L4.96339 62.3552L11.8567 71.8429L21.8267 68.1971C23.9295 69.8779 26.2607 71.3005 28.7659 72.4371L30.0279 82.9658L41.636 84.8044L46.0898 75.1809C48.8236 74.8741 51.4803 74.2415 53.9996 73.2927L62.355 79.8411L71.8428 72.9478L68.1971 62.9776C69.878 60.8749 71.3005 58.5437 72.4371 56.0384L82.9658 54.7766L84.8044 43.1684L75.1809 38.7146C74.8741 35.9808 74.2416 33.324 73.2928 30.8048L79.841 22.4493L72.9477 12.9616L62.9776 16.6073C60.8749 14.9264 58.5437 13.5039 56.0385 12.3673L54.7765 1.83855L43.1684 0Z" />
          </mask>
          <path
            d="M43.1684 0L43.403 -1.48153L42.2833 -1.65889L41.8071 -0.630003L43.1684 0ZM38.7146 9.62347L38.8819 11.1141L39.7212 11.0199L40.0759 10.2535L38.7146 9.62347ZM30.8048 11.5116L29.8796 12.6923L30.5438 13.2128L31.3335 12.9154L30.8048 11.5116ZM22.4493 4.9634L23.3746 3.78277L22.4835 3.08445L21.5677 3.74988L22.4493 4.9634ZM12.9616 11.8567L12.0799 10.6431L11.164 11.3086L11.5528 12.3718L12.9616 11.8567ZM16.6073 21.8267L17.779 22.7633L18.3059 22.1042L18.0161 21.3116L16.6073 21.8267ZM12.3673 28.7659L12.5458 30.2553L13.3844 30.1547L13.7333 29.3856L12.3673 28.7659ZM1.83855 30.0279L1.66003 28.5386L0.53437 28.6735L0.357017 29.7933L1.83855 30.0279ZM0 41.6361L-1.48153 41.4014L-1.65889 42.5212L-0.629995 42.9974L0 41.6361ZM9.62348 46.0897L11.1141 45.9225L11.0199 45.0832L10.2535 44.7285L9.62348 46.0897ZM11.5116 53.9995L12.6923 54.9248L13.2128 54.2606L12.9154 53.4708L11.5116 53.9995ZM4.96339 62.3552L3.78276 61.4299L3.08444 62.3209L3.74987 63.2368L4.96339 62.3552ZM11.8567 71.8429L10.6431 72.7246L11.3086 73.6405L12.3718 73.2517L11.8567 71.8429ZM21.8267 68.1971L22.7633 67.0254L22.1041 66.4985L21.3116 66.7883L21.8267 68.1971ZM28.7659 72.4371L30.2553 72.2586L30.1548 71.42L29.3857 71.0711L28.7659 72.4371ZM30.0279 82.9658L28.5385 83.1443L28.6735 84.27L29.7932 84.4473L30.0279 82.9658ZM41.636 84.8044L41.4014 86.2859L42.5211 86.4633L42.9973 85.4344L41.636 84.8044ZM46.0898 75.1809L45.9225 73.6903L45.0832 73.7844L44.7285 74.5509L46.0898 75.1809ZM53.9996 73.2927L54.9248 72.1121L54.2606 71.5916L53.4709 71.889L53.9996 73.2927ZM62.355 79.8411L61.4298 81.0217L62.3208 81.72L63.2367 81.0546L62.355 79.8411ZM71.8428 72.9478L72.7245 74.1613L73.6404 73.4959L73.2516 72.4327L71.8428 72.9478ZM68.1971 62.9776L67.0254 62.041L66.4985 62.7002L66.7883 63.4928L68.1971 62.9776ZM72.4371 56.0384L72.2586 54.5491L71.42 54.6496L71.0711 55.4187L72.4371 56.0384ZM82.9658 54.7766L83.1443 56.2659L84.27 56.131L84.4473 55.0112L82.9658 54.7766ZM84.8044 43.1684L86.2859 43.4031L86.4633 42.2833L85.4344 41.8071L84.8044 43.1684ZM75.1809 38.7146L73.6903 38.8819L73.7844 39.7212L74.5509 40.0759L75.1809 38.7146ZM73.2928 30.8048L72.1121 29.8796L71.5916 30.5438L71.889 31.3335L73.2928 30.8048ZM79.841 22.4493L81.0216 23.3746L81.7199 22.4835L81.0545 21.5676L79.841 22.4493ZM72.9477 12.9616L74.1612 12.0799L73.4958 11.164L72.4326 11.5528L72.9477 12.9616ZM62.9776 16.6073L62.041 17.7789L62.7002 18.3059L63.4928 18.0161L62.9776 16.6073ZM56.0385 12.3673L54.5491 12.5458L54.6496 13.3844L55.4187 13.7333L56.0385 12.3673ZM54.7765 1.83855L56.2659 1.66004L56.1309 0.534371L55.0112 0.357017L54.7765 1.83855ZM41.8071 -0.630003L37.3533 8.99346L40.0759 10.2535L44.5297 0.630003L41.8071 -0.630003ZM38.5474 8.13282C35.6935 8.45306 32.9151 9.11394 30.2761 10.1079L31.3335 12.9154C33.733 12.0116 36.268 11.4074 38.8819 11.1141L38.5474 8.13282ZM31.7301 10.331L23.3746 3.78277L21.5241 6.14403L29.8796 12.6923L31.7301 10.331ZM21.5677 3.74988L12.0799 10.6431L13.8432 13.0702L23.331 6.17693L21.5677 3.74988ZM11.5528 12.3718L15.1985 22.3419L18.0161 21.3116L14.3703 11.3415L11.5528 12.3718ZM15.4357 20.8901C13.6748 23.0928 12.1878 25.531 11.0013 28.1462L13.7333 29.3856C14.82 26.9903 16.178 24.7661 17.779 22.7633L15.4357 20.8901ZM12.1888 27.2766L1.66003 28.5386L2.01707 31.5173L12.5458 30.2553L12.1888 27.2766ZM0.357017 29.7933L-1.48153 41.4014L1.48153 41.8707L3.32008 30.2626L0.357017 29.7933ZM-0.629995 42.9974L8.99348 47.451L10.2535 44.7285L0.629995 40.2748L-0.629995 42.9974ZM8.13283 46.257C8.45308 49.1109 9.11394 51.8892 10.1079 54.5283L12.9154 53.4708C12.0116 51.0714 11.4074 48.5364 11.1141 45.9225L8.13283 46.257ZM10.331 53.0743L3.78276 61.4299L6.14403 63.2804L12.6923 54.9248L10.331 53.0743ZM3.74987 63.2368L10.6431 72.7246L13.0702 70.9612L6.17692 61.4735L3.74987 63.2368ZM12.3718 73.2517L22.3419 69.6058L21.3116 66.7883L11.3415 70.4342L12.3718 73.2517ZM20.8901 69.3687C23.0928 71.1295 25.531 72.6166 28.1462 73.8031L29.3857 71.0711C26.9904 69.9844 24.7661 68.6263 22.7633 67.0254L20.8901 69.3687ZM27.2766 72.6156L28.5385 83.1443L31.5172 82.7873L30.2553 72.2586L27.2766 72.6156ZM29.7932 84.4473L41.4014 86.2859L41.8707 83.3228L30.2625 81.4843L29.7932 84.4473ZM42.9973 85.4344L47.451 75.8109L44.7285 74.5509L40.2747 84.1744L42.9973 85.4344ZM46.257 76.6715C49.1109 76.3513 51.8893 75.6904 54.5282 74.6965L53.4709 71.889C51.0714 72.7927 48.5364 73.3969 45.9225 73.6903L46.257 76.6715ZM53.0743 74.4734L61.4298 81.0217L63.2803 78.6605L54.9248 72.1121L53.0743 74.4734ZM63.2367 81.0546L72.7245 74.1613L70.9611 71.7343L61.4734 78.6276L63.2367 81.0546ZM73.2516 72.4327L69.6059 62.4625L66.7883 63.4928L70.434 73.463L73.2516 72.4327ZM69.3687 63.9142C71.1295 61.7115 72.6166 59.2734 73.8031 56.6582L71.0711 55.4187C69.9844 57.814 68.6264 60.0383 67.0254 62.041L69.3687 63.9142ZM72.6156 57.5278L83.1443 56.2659L82.7873 53.2872L72.2586 54.5491L72.6156 57.5278ZM84.4473 55.0112L86.2859 43.4031L83.3228 42.9338L81.4843 54.5419L84.4473 55.0112ZM85.4344 41.8071L75.8109 37.3533L74.5509 40.0759L84.1744 44.5297L85.4344 41.8071ZM76.6716 38.5473C76.3513 35.6935 75.6904 32.9151 74.6965 30.2761L71.889 31.3335C72.7927 33.733 73.397 36.268 73.6903 38.8819L76.6716 38.5473ZM74.4734 31.7301L81.0216 23.3746L78.6603 21.5241L72.1121 29.8796L74.4734 31.7301ZM81.0545 21.5676L74.1612 12.0799L71.7342 13.8432L78.6274 23.331L81.0545 21.5676ZM72.4326 11.5528L62.4625 15.1985L63.4928 18.0161L73.4629 14.3703L72.4326 11.5528ZM63.9143 15.4356C61.7116 13.6748 59.2734 12.1877 56.6582 11.0013L55.4187 13.7333C57.8141 14.82 60.0383 16.178 62.041 17.7789L63.9143 15.4356ZM57.5278 12.1888L56.2659 1.66004L53.2872 2.01706L54.5491 12.5458L57.5278 12.1888ZM55.0112 0.357017L43.403 -1.48153L42.9337 1.48153L54.5419 3.32008L55.0112 0.357017Z"
            fill="#00A9A5"
            mask="url(#path-5-inside-1)"
          />
          <path
            d="M61.0159 45.0143C59.3528 55.5149 49.4922 62.6791 38.9916 61.0159C28.491 59.3528 21.3268 49.4922 22.9899 38.9916C24.6531 28.491 34.5137 21.3268 45.0143 22.9899C55.5149 24.6531 62.6791 34.5137 61.0159 45.0143Z"
            stroke="#F9F8F8"
            strokeWidth="1.5"
          />
        </Svg>
      </IntersectionVisible>
    )
  }
}
